<template>
  <label class="checkbox">
    <input
      v-model="stateValue"
      type="checkbox"
      class="input-checkbox"
      :title="title"
      @change="change"
    >
    <span
      class="i-custom-checkbox"
      :class="customCheckboxClassName"
    />
    <slot />
  </label>
</template>

<script>
export default {
  name: 'CheckboxIndex',
  props: {
    value: {
      type: Boolean,
      default () {
        return false
      }
    },
    title: {
      type: String,
      default () {
        return ''
      }
    },
    customCheckboxClassName: {
      type: String,
      default () {
        return ''
      }
    }
  },

  data () {
    return {
      stateValue: false
    }
  },

  watch: {
    value (newVal) {
      this.stateValue = newVal
    }
  },

  mounted () {
    this.stateValue = this.value
  },

  methods: {
    change (event) {
      this.$emit('change', this.stateValue)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main';

.checkbox {
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-start;

  > * {
    flex-shrink: 0;
  }
}

.input-checkbox {
  position: absolute;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}

$s = 14px
$m = 2px
.i-custom-checkbox {
  position: relative;
  display: inline-flex;
  width: $s;
  height: $s;
  margin: $m;
  border-radius: 2px;
  border-width: 1px;
  border-color: #24252a;
  border-style: solid;
  background-size: 70%;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: $white;

  & + * {
    margin-left: 5px;
    line-height: $s + $m * 2;
    width: "calc(100% - %s)" % ($s + $m * 2);
  }
}

.input-checkbox:checked ~ .i-custom-checkbox {
  background-color: #24252a;
  background-image: embedurl('./checked.svg');
}
</style>
